export const BASE_URL =
  "https://service-izm02nm6-1302190278.sg.apigw.tencentcs.com/release";
